import React from "react";
import { useNavigate } from 'react-router-dom';
import Lastreons from "../../../Assets/Lastreons.png";
import style from "./style.module.css";

const Header = ({ auth = false, user}) => {

    const navigate = useNavigate();

    return (
        <>
            {!auth ?
                <div className={style.rootDiv}>
                    <div className={style.navigation}>
                        <h1 className={style.logo} onClick={() => navigate("/minecraft")}>LASTRA</h1>
                    </div>
                </div>
                :
                <div className={style.rootDiv}>
                    <div className={style.navigation}>
                        <h1 className={style.logo} onClick={() => navigate("/minecraft")}>LASTRA</h1>
                        <div className={style.middle}>
                            <p className={style.home} onClick={() => navigate("/minecraft")}>HOME</p>
                            <div className={style.store}>
                                <p>STORE</p>
                                <svg viewBox="0 0 512 512">
                                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                </svg>
                                <div className={style.dropDown}>
                                    <button onClick={() => navigate("/minecraft/shop")}>Shop</button>
                                    <button onClick={() => navigate("/minecraft/coins")}>Coins</button>
                                    <button onClick={() => navigate("/minecraft/vip")}>VIP</button>
                                    {/* <button onClick={() => navigate("/minecraft/bundles")}>Bundles</button> */}
                                </div>
                            </div>
                            <div className={style.gameFeatures}>
                                <p>GAME FEATURES</p>
                                <svg viewBox="0 0 512 512">
                                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                </svg>
                                <div className={style.dropDown}>
                                    <button onClick={() => navigate("/minecraft/daily-rewards")}>Daily Rewards</button>
                                    <button onClick={() => navigate("/minecraft/bank")}>Bank</button>
                                    <button onClick={() => navigate("/minecraft/party")}>Party</button>
                                </div>
                            </div>
                            <div className={style.support}>
                                <p>SUPPORT</p>
                                <svg viewBox="0 0 512 512">
                                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                </svg>
                                <div className={style.dropDown}>
                                    <button>Feedback</button>
                                    <button onClick={() => window.location.href="https://buymeacoffee.com/lastra"}>Buymeacoffee</button>
                                </div>
                            </div>
                            <div className={style.socials}>
                                <p>SOCIALS</p>
                                <svg viewBox="0 0 512 512">
                                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                </svg>
                                <div className={style.dropDown}>
                                    <button onClick={() => window.location.href="https://www.instagram.com/lastra_qilxy"}>Instagram</button>
                                    <button onClick={() => window.location.href="https://discord.gg/AXXeqJaXPp"}>Discord</button>
                                </div>
                            </div>
                        </div>
                        <div className={style.right}>
                            <p className={style.lastreons}>2560</p>
                            <img src={Lastreons} alt="Astreons" />
                            <p className={style.money}>{user.money}</p>
                            <svg viewBox="0 0 320 512">
                                <path d="M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default Header;